import AuthGuard from './auth-guard'
import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/layouts/dashboard/Dashboard'
import Profile from '@/layouts/profile/Profile'
import Signup from '@/components/User/Signup'
import Signin from '@/components/User/Signin'
import Documents from '@/layouts/documentation/Documents'
import MarkdownExample from '@/layouts/documentation/MarkdownExample'
import Financial from '@/layouts/financial/Financial'
import Design from '@/layouts/design/Design'
import Legal from '@/layouts/legal/Legal'
import Marketing from '@/layouts/marketing/Marketing'
import Homepage from '@/layouts/home/Home'
import Blog from '@/layouts/blog/Blog'
import Members from '@/layouts/team/Members'
import Standards from '@/layouts/standards/Standards'
import Wiki from '@/layouts/wiki/Wiki'
import Sandbox from '@/layouts/sandbox/Sandbox'
import Reference from '@/layouts/reference/Reference'

/**
 * Snippet for a routes array element
 
 {
    path: '/',
    name: '',
    component: Template
 }
  
 *
 * 
 ** Use AuthGuard to prevent access from unauthorized users
 {
    path: '/',
    name: '',
    component: Template,
    beforeEnter: AuthGuard
 }
 */

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'AmmoNyte',
      component: Homepage
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/docs',
      name: 'Documents',
      component: Documents,
      beforeEnter: AuthGuard
    },
    {
      path: '/markdown',
      name: 'Markdown Example',
      component: MarkdownExample,
      beforeEnter: AuthGuard
    },
    {
      path: '/financial',
      name: 'Financial',
      component: Financial,
      beforeEnter: AuthGuard
    },
    {
      path: '/marketing',
      name: 'Marketing',
      component: Marketing,
      beforeEnter: AuthGuard
    },
    {
      path: '/design',
      name: 'Design',
      component: Design,
      beforeEnter: AuthGuard
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal,
      beforeEnter: AuthGuard
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: Signup
    },
    {
      path: '/login',
      name: 'Login',
      component: Signin
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      beforeEnter: AuthGuard
    },
    {
      path: '/members',
      name: 'Members',
      component: Members,
      beforeEnter: AuthGuard
    },
    {
      path: '/standards',
      name: 'Standards',
      component: Standards,
      beforeEnter: AuthGuard
    },
    {
      path: '/wiki',
      name: 'Wiki',
      component: Wiki,
      beforeEnter: AuthGuard
    },
    {
      path: '/sandbox',
      name: 'Sandbox',
      component: Sandbox
    },
    {
      path: '/reference',
      name: 'Reference', 
      component: Reference
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js